import React, { useEffect, useState } from "react";
import { useSession, useUser } from "@clerk/clerk-react";
import { Card, CardHeader, CardBody, CardFooter } from "@heroui/card";
import { Avatar } from "@heroui/avatar";
import { Button } from "@heroui/button";
import { useNavigate } from "react-router-dom";
import { MapPin } from "lucide-react";
import { formatDate, isMeetingActive, isMeetingUpcoming } from "@/utils/dates";
import LocationMapsIcon from "../maps/LocationOpenMapsIcon";

const ActiveMeetingCard = ({ _record, _onResp }) => {
const navigate = useNavigate()
const { user } = useUser()
const [record, setRecord] = useState(null)
const [activeMeets, setActiveMeets] = useState(false);
const [isUpComingMeets, setIsUpcomingMeets] = useState(false)

useEffect(()=> {
  setRecord(_record)
  checkIfActive(_record)
  checkIfUpcoming(_record)
}, [_record])

function checkIfActive(_rec){
  const meeting_date = _rec['meeting_date'];
  const start_time = _rec['start_time']['set'];
  const end_time = _rec['end_time']['real'];
  const result = isMeetingActive(meeting_date, start_time, end_time)
  setActiveMeets(result)
}

function checkIfUpcoming(_rec){
  const meeting_date = _rec['meeting_date'];
  const start_time = _rec['start_time']['set'];
  const end_time = _rec['end_time']['set'];
  const result = isMeetingUpcoming(meeting_date, start_time, end_time)
  setIsUpcomingMeets(result)
}

if(record === null){
  return <><h2>Loading...</h2></>
}

function onCardClick() {
  const userId = user?.id;
  const hostId = record?.created_by?.user_id;
  const code   = record?.short_code;

  if (userId !== hostId) return navigate(`/meetings/view/${code}`);
  if (activeMeets)       return navigate(`/meetings/join/${code}`);
  // if (isUpComingMeets)   return navigate(`/meetings/edit/${code}`);
  return navigate(`/meetings/view/${code}`);
}

function onMapClick(_rec){
  console.log(_rec)
}

return (
<>
  <Card className="relative max-w-[360px] rounded-xl border border-neutral-200 bg-white shadow-sm
      hover:shadow-md transition-shadow cursor-pointer
      dark:border-default-200 dark:bg-content1 dark:shadow-lg
    ">
  <CardBody onClick={() => onCardClick(record)} className="px-4 py-3">
    <div className="flex items-center justify-between">
      <h3 className="text-base font-semibold text-neutral-800 dark:text-foreground capitalize">
        {record["title"]}
      </h3>
      <small className="text-primary font-medium">
        {record["start_time"]['set']} – {record["end_time"]['set']}
      </small>
    </div>
    <p className="text-sm mt-1 text-neutral-700 dark:text-default-500 line-clamp-2">
      {record["description"] === "" ? (
        <span className="italic text-neutral-400 dark:text-default-500">
          No Description...
        </span>
      ) : (
        <span>{record["description"]}</span>
      )}
    </p>
  </CardBody>

  <CardFooter className="px-4 py-2 text-sm text-neutral-600 dark:border-default-100 dark:bg-transparent dark:text-default-400">
    <p>{record["members"].length} participants</p>
  </CardFooter>

  <div className="absolute bottom-2 right-2 ">
    <LocationMapsIcon record={record}/>
  </div>
</Card>
</>
);
};

export default ActiveMeetingCard;